import Accordion from "./Accordion";
import Disclosure from "./Disclosure";
import LoginLink from "./LoginLink";
import NavigationMenu from "./NavigationMenu";
import ScrollPosition from "./ScrollPosition";
import Table from "./Table";
import TagList from "./TagList";

/**
 * Define all custom elements.
 */
function defineElements() {
  if ("customElements" in window) {
    Accordion.define();
    Disclosure.define();
    LoginLink.define();
    NavigationMenu.define();
    ScrollPosition.define();
    Table.define();
    TagList.define();
  }
}

export {
  Accordion,
  Disclosure,
  LoginLink,
  NavigationMenu,
  ScrollPosition,
  Table,
  TagList,
  defineElements,
};
